var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),(_vm.items.length === 0)?_c('p',[_vm._v("Brak elementów")]):_vm._e(),_c('el-button',{staticClass:"add-item-button",attrs:{"type":"warning"},on:{"click":_vm.addItem}},[_vm._v("\n    Dodaj nowy\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }